import { render, staticRenderFns } from "./RatingLog.vue?vue&type=template&id=59c01bb4&scoped=true"
import script from "./RatingLog.vue?vue&type=script&lang=js"
export * from "./RatingLog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59c01bb4",
  null
  
)

export default component.exports